import React from "react";
import ApplicationForm from "../ApplicationForm/ApplicationForm";
import Footer from "./Footer";
import {
  ApplicationFooterReveal,
  ApplicationSection,
  FooterSection,
} from "./Footer.styles";

const ApplicationFooter: React.FC = () => {
  return (
    <ApplicationFooterReveal>
      <ApplicationSection id="application" data-scroll-reveal="false">
        <ApplicationForm />
      </ApplicationSection>
      <FooterSection data-scroll-reveal="false">
        <Footer />
      </FooterSection>
    </ApplicationFooterReveal>
  );
};

export default ApplicationFooter;
